import { useCallback, useRef, useState } from 'react';

import service, { didAbort } from '@/services/index';
import { useToast } from '@/stores/pure/ToastStore';

const useFetchContactSentimentList = () => {
  const [contactSentimentList, setContactSentimentList] = useState<
    CustomerSentimentBaseListItemT[]
  >([]);
  const abortControllerRef = useRef<AbortController>();
  const addToast = useToast();

  const fetchContactSentimentList = useCallback(
    async (params: FetchCustomerSentimentListParams) => {
      try {
        // Abort the previous request if there was one
        abortControllerRef.current?.abort();

        // Create a new AbortController
        abortControllerRef.current = new AbortController();

        const newContactSentimentList =
          await service.customer.fetchContactSentimentList(params, {
            signal: abortControllerRef.current.signal,
          });

        setContactSentimentList(newContactSentimentList);
        return newContactSentimentList;
      } catch (error) {
        console.error(error);
        if (!didAbort(error)) {
          addToast('Failed to get contact list', 'fail');
        }
        return [];
      }
    },
    [addToast],
  );

  return {
    contactSentimentList,
    fetchContactSentimentList,
  };
};

export default useFetchContactSentimentList;
